//  将值存入Session的public中, name可为string或者object
export function session(name, value) {
  let obj = ''
  if (arguments.length < 2) { // 当 参数为 1 个时，取值 key 为 name 的值。当参数为 2 个时，设值 key 为name的值为 value。
    if (sessionStorage.getItem('public')) {
      obj = JSON.parse(sessionStorage.getItem('public'))[name]
    }
    return obj
  } else {
    obj = sessionStorage.getItem('public') ? JSON.parse(sessionStorage.getItem('public')) : {}
    // 判断name类型：
    if (typeof name === 'string') {
      obj[name] = value || ''
    } else if (typeof name === 'object') {
      name.forEach((item, i) => {
        obj[i] = item || ''
      })
    }
    sessionStorage.setItem('public', JSON.stringify(obj))
  }
}

//  将key为【name】的键值对从 public中 删除调, name可为 string 或者 array
export function removeSession(name) {
  let obj = sessionStorage.getItem('public') ? JSON.parse(sessionStorage.getItem('public')) : {};
  // 判断name类型：
  if (typeof name === 'string') {
    delete obj[name]
  } else if (Array.isArray(name)) { // 为数组时
    name.forEach((item) => {
      delete obj[item]
    })
  }
  sessionStorage.setItem('public', JSON.stringify(obj))
}

//  将值存入localStorage的public中, name可为string或者object
export function local(name, value) {
  let obj = ''
  if (arguments.length < 2) { // 当 参数为 1 个时，取值 key 为 name 的值。当参数为 2 个时，设值 key 为name的值为 value。
    if (localStorage.getItem('public')) {
      obj = JSON.parse(localStorage.getItem('public'))[name]
    }
    return obj
  } else {
    obj = localStorage.getItem('public') ? JSON.parse(localStorage.getItem('public')) : {}
    // 判断name类型：
    if (typeof name === 'string') {
      obj[name] = value || ''
    } else if (typeof name === 'object') {
      name.forEach((item, i) => {
        obj[i] = item || ''
      })
    }
    localStorage.setItem('public', JSON.stringify(obj))
  }
}

//  将key为【name】的键值对从 public中 删除调, name可为 string 或者 array
export function removeLocal(name) {
  let obj = localStorage.getItem('public') ? JSON.parse(localStorage.getItem('public')) : {};
  // 判断name类型：
  if (typeof name === 'string') {
    delete obj[name]
  } else if (Array.isArray(name)) { // 为数组时
    name.forEach((item) => {
      delete obj[item]
    })
  }
  localStorage.setItem('public', JSON.stringify(obj))
}